import { render, staticRenderFns } from "./OrgAdminSideNav.vue?vue&type=template&id=76a6cc6f&scoped=true&"
import script from "./OrgAdminSideNav.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./OrgAdminSideNav.vue?vue&type=style&index=0&id=76a6cc6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a6cc6f",
  null
  
)

export default component.exports